import { ErrorHandler, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {Subject} from "rxjs";

// https://www.loggly.com/blog/angular-exception-logging-made-simple/

@Injectable({
  providedIn: 'root',
})
export class EventBusChunkAwareErrorHandler extends ErrorHandler {
  public readonly error$ = new Subject<Response>();

  constructor(private translate: TranslateService) {
    super();
  }

  public handleError(error): void {
    const chunkFailedMessage = /Loading chunk[\w|\s|-]+failed/;
    if (chunkFailedMessage.test(error.message)) {
      alert(this.translate.instant('GENERAL.UPDATE_PORTAL'));
      window.location.reload();
    } else {
      super.handleError(error);
      this.handleErrorType(error);
    }
  }

  private handleErrorType(...err: any[]): void {
    let error = err;
    if (Array.isArray(error)) {
      error = err[0];
    }

    if (error instanceof Error) {
      if (error.message.startsWith('Uncaught (in promise): Error: Loading chunk')) {
        // do not log loading chunk, since we cant do anything except reloading the page
        alert(this.translate.instant('ERROR_MESSAGES.UNKNOWN_RELOAD'));
      }
    }
  }
}
